import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';
import { computed } from 'vue';

// TODO: fix type
interface Props {
  data: any;
  inverted?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RichAdvantages',
  props: {
    data: null,
    inverted: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  data: any;
  inverted?: boolean;
};



const textToList = computed(() => {
  if (Array.isArray(props.data.text)) return props.data.text;
  const arrayOfText = props.data.text.split('\r\n');
  const arrayOfTextTrimed = arrayOfText.filter((n: any) => n);
  return arrayOfTextTrimed;
});

return { __sfc: true,props, textToList, CdnImg }
}

})